import React from "react"
import JavaImg from "../../../images/Java.svg"
import ReactNativeImg from "../../../images/React-native.svg"
import KotlinImg from "../../../images/Kotlin.svg"
import NodeJsImg from "../../../images/Node-js.svg"
import AngularImg from "../../../images/Angularjs.svg"
import GoImg from "../../../images/GO.svg"
import NetImg from "../../../images/NET.svg"
import PythonImg from "../../../images/Python.svg"
import IOSImg from "../../../images/ios.svg"
import AndroidImg from "../../../images/android.svg"
import AWSImg from "../../../images/AWS.svg"
import AzureImg from "../../../images/Azure.svg"
import GoogleCloudImg from "../../../images/Cloud.svg"

const Technologies = () => {
  return (
    <section className="container mx-auto px-6 py-20">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-12 lg:gap-8 lg:grid-cols-3 text-center w-full lg:w-5/6 mx-auto text-secondary font-medium text-3xl lg:text-5xl pb-20">
        <div>
          <img src={JavaImg} alt="Java" className="mx-auto pb-2" />
          Java
        </div>
        <div>
          <img src={KotlinImg} alt="Kotlin" className="mx-auto pb-2" />
          Kotlin
        </div>
        <div>
          <img src={ReactNativeImg} alt="React" className="mx-auto pb-2" />
          React
        </div>
        <div>
          <img src={AngularImg} alt="Angular" className="mx-auto pb-2" />
          Angular
        </div>
        <div>
          <img src={JavaImg} alt="Vue" className="mx-auto pb-2" />
          Vue
        </div>
        <div>
          <img src={NodeJsImg} alt="Node JS" className="mx-auto pb-2" />
          Node JS
        </div>
        <div>
          <img src={GoImg} alt="GO" className="mx-auto pb-2" />
          GO
        </div>
        <div>
          <img src={NetImg} alt=".NET" className="mx-auto pb-2" />
          .NET
        </div>
        <div>
          <img src={PythonImg} alt="Python" className="mx-auto pb-2" />
          Python
        </div>
      </div>

      <div className="flex flex-col md:flex-row-reverse py-20">
        <div className="w-full lg:w-2/3">
          <h3 className="font-normal text-5xl pb-8">
            <span className="font-bold text-secondary">Mobile App</span>{" "}
            development
          </h3>
          <p className="pb-8">
            We have a set of tools to develop applications natively (iOS /
            Android) as hybrid (React Native).
          </p>
        </div>
        <div className="w-full lg:w-3/5 flex flex-wrap justify-center">
          <img src={AndroidImg} alt="Android" />
          <img src={IOSImg} alt="IOS" className="mx-4" />
          <img src={ReactNativeImg} alt="React" />
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row-reverse pt-20">
        <div className="w-full lg:w-3/5 flex flex-wrap justify-center">
          <img src={AWSImg} alt="Amazon Web Services" />
          <img src={AzureImg} alt="Microsoft Azure" className="mx-4" />
          <img src={GoogleCloudImg} alt="Google Cloud" />
        </div>
        <div className="w-full lg:w-2/3">
          <h3 className="font-normal text-5xl pb-8">
            <span className="font-bold text-secondary">Services</span> on Cloud
          </h3>
          <p className="pb-8">
            Our Cloud experts enable us to help organizations accelerate their
            digital transformation process by providing them with best cloud
            infrastructure practices to adapt to new market challenges.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Technologies
